import { MetadataOptions } from "sap/ui/base/ManagedObject";
import Icon from "sap/ui/core/Icon";

/**
 * Shows pretty icon for a boolean value.
 * @namespace akademika.akamont.customControls
 */
export default class BooleanIcon extends Icon {
  static readonly metadata: MetadataOptions = {
    properties: {
      value: { type: "boolean" },
    },
  };

  public setValue(newValue?: boolean) {
    const iconSrc = newValue ? "sap-icon://accept" : "sap-icon://decline";
    const color = newValue ? "Positive" : "Negative";
    this.setSrc(iconSrc);
    this.setColor(color);
  }

  static renderer = { apiVersion: 2 };
}
